// Constants for save status
export const SAVE_STATUS = {
  IDLE: null,
  SAVING: "saving",
  SAVED: "saved",
  ERROR: "error",
};

export const DELETE_TYPES = {
  DELETE: "0",
  SOFT_DELETE: "1",
  RESTORE: "2",
};
// Risk level constants
export const RISK_LEVELS = {
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
};

// Risk score thresholds
export const RISK_THRESHOLDS = {
  MIN_SCORE: 0,
  MAX_SCORE: 3,
  MEDIUM_THRESHOLD: 1.5,
  HIGH_THRESHOLD: 2.5,
};

// Safety index thresholds
export const SAFETY_INDEX_THRESHOLDS = {
  HIGH_RISK: 31,
  MEDIUM_RISK: 65,
};

// Date format constants
export const DATE_FORMATS = {
  DISPLAY: "DD-MMM-YYYY",
  ISO: "YYYY-MM-DD",
};

// UI Constants
export const DEBOUNCE_DELAY = 500;
export const AUTO_HIDE_NOTIFICATION_DELAY = 2000;

// This file is the single source of truth for the structure of the product assessment.
export const TABS_CONFIG = {
  asset: {
    title: "Asset Assessment",
    parameters: [
      {
        key: "maturity",
        label: "Maturity",
        options: ["Mature", "Medium", "Immature"],
      },
      {
        key: "projectRisk",
        label: "Project Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "historicalRisk",
        label: "Historical Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "concentration",
        label: "Concentration >1%",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "regulatoryCompliance",
        label: "Regulatory Compliance",
        options: ["Compliant", "Non-compliant"],
      },
      {
        key: "amlCompliance",
        label: "AML Compliance",
        options: ["No AML Activities", "AML Activities"],
      },
      {
        key: "foundersTeam",
        label: "Founders / Team",
        options: ["Reliable", "Anonymous", "Unreliable"],
      },
      {
        key: "reputation",
        label: "Reputation",
        options: ["Positive", "Negative"],
      },
      {
        key: "lawsuits",
        label: "Lawsuits",
        options: ["No Lawsuits", "Lawsuits Exist"],
      },
    ],
  },
  blockchain: {
    title: "Blockchain Assessment",
    parameters: [
      {
        key: "maturity",
        label: "Maturity",
        options: ["Mature", "Medium", "Immature"],
      },
      {
        key: "projectRisk",
        label: "Project Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "historicalRisk",
        label: "Historical Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "concentration",
        label: "Concentration >1%",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "regulatoryCompliance",
        label: "Regulatory Compliance",
        options: ["Compliant", "Non-compliant"],
      },
      {
        key: "amlCompliance",
        label: "AML Compliance",
        options: ["No AML Activities", "AML Activities"],
      },
      {
        key: "foundersTeam",
        label: "Founders / Team",
        options: ["Reliable", "Anonymous", "Unreliable"],
      },
      {
        key: "reputation",
        label: "Reputation",
        options: ["Positive", "Negative"],
      },
      {
        key: "lawsuits",
        label: "Lawsuits",
        options: ["No Lawsuits", "Lawsuits Exist"],
      },
    ],
  },
  stakingPlatform: {
    title: "Staking Platform Assessment",
    parameters: [
      {
        key: "maturity",
        label: "Maturity",
        options: ["Mature", "Medium", "Immature"],
      },
      {
        key: "security",
        label: "Security",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "historicalSecurityRisk",
        label: "Historical Security Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "historicalSlashingRisk",
        label: "Historical Slashing Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "decentralization",
        label: "Decentralization",
        options: ["Decentralized", "Centralized"],
      },
      {
        key: "regulatoryCompliance",
        label: "Regulatory Compliance",
        options: ["Compliant", "Non-compliant"],
      },
      {
        key: "amlCompliance",
        label: "AML Compliance",
        options: ["No AML Activities", "AML Activities"],
      },
      {
        key: "foundersTeam",
        label: "Founders / Team",
        options: ["Reliable", "Anonymous", "Unreliable"],
      },
      {
        key: "reputation",
        label: "Reputation",
        options: ["Positive", "Negative"],
      },
      {
        key: "legalStanding",
        label: "Legal Standing",
        options: ["No Lawsuits", "Lawsuits Exist"],
      },
      {
        key: "uptime",
        label: "Uptime",
        options: ["High", "Standard", "Limited"],
      },
    ],
  },
  validator: {
    title: "Validator Assessment",
    parameters: [
      {
        key: "maturity",
        label: "Maturity",
        options: ["Mature", "Medium", "Immature"],
      },
      {
        key: "security",
        label: "Security",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "historicalSecurityRisk",
        label: "Historical Security Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "historicalSlashingRisk",
        label: "Historical Slashing Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "decentralization",
        label: "Decentralization",
        options: ["Decentralized", "Centralized"],
      },
      {
        key: "regulatoryCompliance",
        label: "Regulatory Compliance",
        options: ["Compliant", "Non-compliant"],
      },
      {
        key: "amlCompliance",
        label: "AML Compliance",
        options: ["No AML Activities", "AML Activities"],
      },
      {
        key: "foundersTeam",
        label: "Founders / Team",
        options: ["Reliable", "Anonymous", "Unreliable"],
      },
      {
        key: "reputation",
        label: "Reputation",
        options: ["Positive", "Negative"],
      },
      {
        key: "legalStanding",
        label: "Legal Standing",
        options: ["No Lawsuits", "Lawsuits Exist"],
      },
      {
        key: "uptime",
        label: "Uptime",
        options: ["High", "Standard", "Limited"],
      },
    ],
  },
  stakingMechanism: {
    title: "Staking Mechanism Assessment",
    parameters: [
      {
        key: "stakingMechanismRisk",
        label: "Staking Mechanism Risk",
        options: ["Low", "Medium", "High"],
      },
    ],
  },
  slashing: {
    title: "Slashing Assessment",
    parameters: [
      {
        key: "slashingRisk",
        label: "Slashing Risk",
        options: ["Low", "Medium", "High"],
      },
    ],
  },
  liquidity: {
    title: "Liquidity Assessment",
    parameters: [
      {
        key: "liquidityRisk",
        label: "Liquidity Risk",
        options: ["Low", "Medium", "High"],
      },
    ],
  },
  stakedValue: {
    title: "Staked Value Assessment",
    parameters: [
      {
        key: "stakedValueRisk",
        label: "Staked Value Risk",
        options: ["Low", "Medium", "High"],
      },
      {
        key: "stakedAmount",
        label: "Staked Amount",
        options: ["Low", "Medium", "High"],
      }, // Note: amount field might need a different input type later
    ],
  },
  tvl: {
    title: "TVL Assessment",
    parameters: [
      { key: "tvlRisk", label: "TVL Risk", options: ["Low", "Medium", "High"] },
    ],
  },
  stakingByCompetitors: {
    title: "Staking by Competitors Assessment",
    parameters: [
      {
        key: "competitorsRisk",
        label: "Competitors Risk",
        options: ["Low", "Medium", "High"],
      },
    ],
  },
  stakingProcedure: {
    title: "Staking Procedure Assessment",
    parameters: [
      {
        key: "procedureRisk",
        label: "Procedure Risk",
        options: ["Low", "Medium", "High"],
      },
    ],
  },
};

// Helper to convert the TABS_CONFIG to the format used by the Dashboard
export const getDashboardCategories = () =>
  Object.entries(TABS_CONFIG).map(([key, value]) => ({
    key,
    name: value.title,
    params: value.parameters.map((p) => p.key),
  }));
